import { render, staticRenderFns } from "./WorkflowTags.vue?vue&type=template&id=75d364b0&scoped=true&"
import script from "./WorkflowTags.vue?vue&type=script&lang=js&"
export * from "./WorkflowTags.vue?vue&type=script&lang=js&"
import style0 from "./WorkflowTags.vue?vue&type=style&index=0&id=75d364b0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75d364b0",
  null
  
)

export default component.exports